import { render, staticRenderFns } from "./BaseText.vue?vue&type=template&id=5225550e&scoped=true&"
import script from "./BaseText.vue?vue&type=script&lang=ts&"
export * from "./BaseText.vue?vue&type=script&lang=ts&"
import style0 from "./BaseText.vue?vue&type=style&index=0&id=5225550e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5225550e",
  null
  
)

export default component.exports